import request from "root/js/request";

export const getParsersSupplierArticleAdvertsLimits = async () => {
  const response = await request({
    url: "parsers/supplier_article_adverts/limits/",
    method: "get",
  });
  return response.data;
};
